// this file is generated by generate-icons.js. Do not edit!
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SVGInfo = props => /*#__PURE__*/_jsxs("svg", Object.assign({
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M15.86 31.86c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16m0-29.72C8.3 2.14 2.15 8.29 2.15 15.85S8.3 29.56 15.86 29.56s13.71-6.15 13.71-13.71S23.42 2.14 15.86 2.14"
  }), /*#__PURE__*/_jsx("path", {
    d: "M15.86 25c-.63 0-1.14-.51-1.14-1.14V13.57a1.14 1.14 0 112.28 0v10.29c0 .63-.51 1.14-1.14 1.14"
  }), /*#__PURE__*/_jsx("circle", {
    cx: 15.86,
    cy: 8.43,
    r: 0.57
  }), /*#__PURE__*/_jsx("path", {
    d: "M15.86 10.14a1.71 1.71 0 11-.002-3.418 1.71 1.71 0 01.002 3.418m0-2.28a.57.57 0 100 1.14.57.57 0 000-1.14m0 6.85h-3.43a1.14 1.14 0 110-2.28h3.43a1.14 1.14 0 110 2.28M20.43 25h-9.14a1.14 1.14 0 110-2.28h9.14a1.14 1.14 0 110 2.28"
  })]
}));
SVGInfo.displayName = 'SVGInfo';
export default SVGInfo;